<admin-page-simple-content
    [icon]="'assignment'"
    [pageError]="pageError"
    [pageStatus]="pageStatus"
    [title]="'Settings: General'"
>
    @if (storeConfig && storeWithConfig) {
        <div class="content">
            <p>Any changes made to the configuration may take up to 2 minutes to become effective.</p>
            <form #form="ngForm" (ngSubmit)="save()">
                <div class="config-checkbox">
                    <mat-checkbox [(ngModel)]="storeConfig.allowAnonymousRequest" name="allowAnonymousRequest">
                        Allow anonymous requests
                    </mat-checkbox>
                    <span class="mat-caption"
                    >Whether calls without authentication are allowed. Only used for native embedded
                        integrations.</span
                    >
                </div>
                <div class="config-checkbox">
                    <mat-checkbox [(ngModel)]="storeConfig.isProofingEnabled" name="isProofingEnabled">
                        Enable Proofing Mode
                    </mat-checkbox>
                    <span class="mat-caption"
                    >Prevents orders from being sent to fulfillment before the order has been approved. See
                        <a
                            class="external"
                            href="https://doc.mediaclip.ca/hub/features/proofing/"
                            rel="external"
                            target="blank"
                        >
                            proofing workflow
                            <mat-icon>open_in_new</mat-icon> </a
                        >.
                    </span>
                </div>
                <div class="config-checkbox">
                    <mat-checkbox [(ngModel)]="storeConfig.uploadInBackgroundEnabled" name="uploadInBackgroundEnabled">
                        Upload In Background
                    </mat-checkbox>
                    <span class="mat-caption">
                        Enable Upload In Background feature. Photos will be uploaded while the user is designing it's
                        project.
                    </span>
                </div>
                <div class="config-checkbox">
                    <mat-checkbox [(ngModel)]="storeConfig.webhookLogEnabled" name="webhookLogEnabled">
                        Enable Webhook Logs
                    </mat-checkbox>
                    <span class="mat-caption">
                        Enable logging call to the status update, and project deletion notification endpoints.
                        <a href="#" [routerLink]="['../../webhook-logs']">See logs</a>
                    </span>
                </div>
                <div class="config-checkbox">
                    <mat-checkbox [(ngModel)]="storeConfig.enableThumbnailGeneration" name="enableThumbnailGeneration">
                        Enable project thumbnails
                    </mat-checkbox>
                    <span class="mat-caption"> When enabled, allow to use project thumbnails. </span>
                </div>

                <div class="config-checkbox">
                    @if (!storeWithConfig.config.useSecureRenewToken) {
                        <mat-checkbox [(ngModel)]="storeConfig.useSecureRenewToken" name="useSecureRenewToken">
                            Use secure renew token
                            <span class="warning">(This setting cannot be disabled once enabled.)</span>
                        </mat-checkbox>
                    } @else {
                        <mat-checkbox [checked]="true" disabled="true">
                            Use secure renew token (This setting cannot be disabled)
                        </mat-checkbox>
                    }

                    <span class="mat-caption">
                            When enabled, enforce the presence of the field <code>storeData.userId</code> when calling the endpoint.
                            See the <a href="https://doc.mediaclip.ca/hub/api/tokens/renew-token/" target="_blank" class="external">documentation <mat-icon>open_in_new</mat-icon></a> for more information.
                    </span>
                </div>
                <div class="trusted-external-photo-hosts">
                    <h3>Trusted External Photo Hosts</h3>
                    <span class="mat-caption">
                            See the <a href="https://doc.mediaclip.ca/hub/features/beauty-shots/beauty-shots/" target="_blank" class="external">documentation <mat-icon>open_in_new</mat-icon></a> for more information.
                    </span>
                    @if (trustedExternalPhotoHostInputError) {
                        <mat-error>
                            {{ trustedExternalPhotoHostInputError }}
                        </mat-error>
                    }
                    <div class="add-url-row">
                        <mat-form-field>
                            <mat-label>Add trusted Host</mat-label>
                            <input
                                matInput
                                [(ngModel)]="trustedExternalPhotoHostInput"
                                name="trustedExternalPhotoHostInput"
                                placeholder="https://example.com"
                            />
                        </mat-form-field>

                        <button mat-icon-button
                            type="button"
                            (click)="addTrustedExternalPhotoHost()"
                            [disabled]="!trustedExternalPhotoHostInput.trim()"
                        >
                            <mat-icon>add</mat-icon>
                        </button>
                    </div>

                    @if (storeConfig.trustedExternalPhotoHosts?.length) {
                        <div class="mat-caption">Current list:</div>
                        <ul>
                            @for (host of storeConfig.trustedExternalPhotoHosts; track host) {
                                <li>
                                    {{ host }}
                                    <button mat-icon-button
                                        type="button"
                                        aria-label="Remove url"
                                        (click)="removeTrustedExternalPhotoHost(host)"
                                    >
                                        <mat-icon>delete</mat-icon>
                                    </button>
                                </li>
                            }
                        </ul>
                    } @else {
                        <div class="mat-caption">No trusted host configured yet.</div>
                    }
                </div>

                <admin-save-button [disabled]="!form.valid" [pageStatus]="pageStatus"></admin-save-button>
            </form>
        </div>
    }

    <div>
        @if (pageStatus === "saveError" && pageError) {
            <admin-error [error]="pageError"></admin-error>
        }
    </div>
</admin-page-simple-content>
